import { ButtonRadioGroupField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox';
import { IAppState, Dispatch } from '../../../../common/state';
import { changeApartment, changePenthouse } from '../../../state/advanced/dwelling_status';
import { InlineParam, Row } from '../markup';

export interface IDwellingStatusProps {
  withApartment: boolean | undefined;
  onApartmentChanged(value: boolean | undefined): void;

  withPenthouse: boolean;
  onPenthouseChanged(value: boolean): void;
}

export const dwellingStatus: React.StatelessComponent<IDwellingStatusProps> = props => (
  <Row title="Статус помещения">
    <InlineParam>
      <ButtonRadioGroupField
        uncheckable
        value={String(props.withApartment)}
        onValueChange={value => props.onApartmentChanged(value !== undefined ? value === 'true' : undefined)}
        values={[
          { value: 'false', label: 'Без апартаментов' },
          { value: 'true', label: 'Только апартаменты' },
        ]}
      />
    </InlineParam>
    <InlineParam>
      <ButtonCheckbox onValueChange={value => props.onPenthouseChanged(value)} value={props.withPenthouse}>
        Пентхаус
      </ButtonCheckbox>
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    withApartment: state.filters.jsonQuery.apartment
      ? state.filters.jsonQuery.apartment.value
      : state.filters.jsonQuery.only_flat && !state.filters.jsonQuery.only_flat.value,
    withPenthouse: (state.filters.jsonQuery.penthouse && state.filters.jsonQuery.penthouse.value) || false,
  }),
  (dispatch: Dispatch) => ({
    onApartmentChanged: (value: boolean | undefined) => {
      dispatch(changeApartment(value));
    },
    onPenthouseChanged: (value: boolean) => {
      dispatch(changePenthouse(value));
    },
  }),
)(dwellingStatus);
